export class ServiceBundleModel {
    constructor(bundle) {
        this.uuid = bundle.uuid;
        this.name = bundle.name;
        this.description = bundle.description;
    }
    // Replace white spaces with dash(-)
    get key() {
        const lowerCasedKey = this.name.toLowerCase();
        return lowerCasedKey.replace(/\s/g, '-');
    }
}
